import Invoice from '@spike/invoice-model';
import { SingleSaleDetail } from '@spike/single-sale-model';
import InvoiceResume from 'components/Checkout2/InvoiceResume';
import { FunctionComponent } from 'react';
import { isTemporalEmail } from 'utils/ValidationUtils';
import { formatItemType, formatMoney } from '../SaleDetailUtils';
import styles from './SaleDetailBody.module.scss';

interface SaleDetailBodyProps {
    sale: SingleSaleDetail;
    invoice?: Invoice;
    loadingInvoice?: boolean;
}

export const SaleDetailBody: FunctionComponent<SaleDetailBodyProps> = ({ sale, invoice, loadingInvoice }) => {
    const clientEmail = sale.client?.email;
    const showClientEmail = clientEmail && !isTemporalEmail(clientEmail);

    return (
        <>
            <section className={styles.client}>
                <h3>{sale.client?.name ?? '-'}</h3>
                {sale.client?.phone && <p>{sale.client.phone}</p>}
                {showClientEmail && <p>{clientEmail}</p>}
            </section>

            <section className={styles.items}>
                {sale.items.map(item => (
                    <div
                        key={item.id}
                        className={styles.item}
                    >
                        <div>
                            <strong>{item.name}</strong>
                            <span>{formatItemType(item.type)}</span>
                            {Number(item.discount) > 0 && <small>Discount {formatMoney(item.discount)}</small>}
                        </div>
                        <strong className={styles.itemPrice}>
                            {item.quantity > 1 && `${item.quantity}x `}
                            {formatMoney(item.amount)}
                        </strong>
                    </div>
                ))}
            </section>

            <section className={styles.totals}>
                <InvoiceResume
                    invoice={invoice}
                    loadingInvoice={loadingInvoice}
                    combineItemDiscounts
                />
            </section>

            {sale.notes && (
                <section className={styles.notes}>
                    <h3>Sale Notes</h3>
                    <p>{sale.notes}</p>
                </section>
            )}
        </>
    );
};

export default SaleDetailBody;
